import { createSortOption } from "@nosto/preact"
export const sizes = [36, 72, 108]

export const sortOptions = [
    createSortOption("score", "Most relevant", { field: "score", order: "desc" }),
    createSortOption("-price", "Price descending", { field: "price", order: "desc" }),
    createSortOption("price", "Price ascending", { field: "price", order: "asc" })
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5
}
